module.exports = __webpack_public_path__ + "img/1532790885.49161c0b.jpg";